import { managerHttp } from '../utils/http';
import { Response } from '../types/resp';
import { ManagerConfigResult } from '../types/manager';
import { SITE_PREFIX } from '../utils/site-config';

// manager wraps the internal admin backend (wp-themes-manager-api). It only
// exposes the public by-prefix config read this theme needs; all writes stay in
// the dashboard.
export const manager = {
	config: async () => {
		return managerHttp.get<Response<ManagerConfigResult>>(
			`/themes/by-prefix/${encodeURIComponent(SITE_PREFIX)}/config`,
		);
	},
};
